<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';

const wrapperRef = ref(null);
const minimized = ref(false);

const toggleEditorExpand = () => {
  minimized.value = !minimized.value;
};

const resetEditorHeight = () => {
  minimized.value = false;
};

const handleMessageSent = () => {
  minimized.value = false;
};

const handleEditorInput = () => {
  if (minimized.value) {
    minimized.value = false;
  }
};

onMounted(() => {
  emitter.on(BUS_EVENTS.MESSAGE_SENT, handleMessageSent);
  const el = wrapperRef.value;
  if (el) {
    el.addEventListener('input', handleEditorInput, true);
  }
});

onBeforeUnmount(() => {
  emitter.off(BUS_EVENTS.MESSAGE_SENT, handleMessageSent);
  const el = wrapperRef.value;
  if (el) {
    el.removeEventListener('input', handleEditorInput, true);
  }
});

defineExpose({ toggleEditorExpand, resetEditorHeight });
</script>

<template>
  <div
    ref="wrapperRef"
    class="relative resizable-editor-wrapper"
    :class="{ 'editor-minimized': minimized }"
  >
    <slot />
  </div>
</template>
